export const links = {
  twitter: "https://twitter.com/weareGamkat",
  discord: "https://discord.gg/EjF8gvcsJc",
  facebook: "https://web.facebook.com/wearegamkat/",
  video: "#",
  gamkat: "https://gamkat.com/",
}